/* eslint-disable no-bitwise */

import { invariant } from '../util/invariant';
import { scalefactor_huffman_codebook, spectrum_huffman_codebook_1, spectrum_huffman_codebook_10, spectrum_huffman_codebook_11, spectrum_huffman_codebook_2, spectrum_huffman_codebook_3, spectrum_huffman_codebook_4, spectrum_huffman_codebook_5, spectrum_huffman_codebook_6, spectrum_huffman_codebook_7, spectrum_huffman_codebook_8, spectrum_huffman_codebook_9 } from './huffman_tables';
import type { BitReader } from './bitReader';

type HuffmanLeaf = number;
type HuffmanNode = HuffmanTree[];
export type HuffmanTree = HuffmanNode | HuffmanLeaf;


let scalefactor_huffman_tree: HuffmanTree | undefined;
let spectrum_huffman_tree_1: HuffmanTree | undefined;
let spectrum_huffman_tree_2: HuffmanTree | undefined;
let spectrum_huffman_tree_3: HuffmanTree | undefined;
let spectrum_huffman_tree_4: HuffmanTree | undefined;
let spectrum_huffman_tree_5: HuffmanTree | undefined;
let spectrum_huffman_tree_6: HuffmanTree | undefined;
let spectrum_huffman_tree_7: HuffmanTree | undefined;
let spectrum_huffman_tree_8: HuffmanTree | undefined;
let spectrum_huffman_tree_9: HuffmanTree | undefined;
let spectrum_huffman_tree_10: HuffmanTree | undefined;
let spectrum_huffman_tree_11: HuffmanTree | undefined;


export function get_scalefactor_huffman_tree() {
  if (scalefactor_huffman_tree === undefined) {
    scalefactor_huffman_tree = makeHuffmanTree(scalefactor_huffman_codebook);
  }

  return scalefactor_huffman_tree;
}


export function get_spectrum_huffman_tree_1() {
  if (spectrum_huffman_tree_1 === undefined) {
    spectrum_huffman_tree_1 = makeHuffmanTree(spectrum_huffman_codebook_1);
  }

  return spectrum_huffman_tree_1;
}


export function get_spectrum_huffman_tree_2() {
  if (spectrum_huffman_tree_2 === undefined) {
    spectrum_huffman_tree_2 = makeHuffmanTree(spectrum_huffman_codebook_2);
  }

  return spectrum_huffman_tree_2;
}


export function get_spectrum_huffman_tree_3() {
  if (spectrum_huffman_tree_3 === undefined) {
    spectrum_huffman_tree_3 = makeHuffmanTree(spectrum_huffman_codebook_3);
  }

  return spectrum_huffman_tree_3;
}


export function get_spectrum_huffman_tree_4() {
  if (spectrum_huffman_tree_4 === undefined) {
    spectrum_huffman_tree_4 = makeHuffmanTree(spectrum_huffman_codebook_4);
  }

  return spectrum_huffman_tree_4;
}


export function get_spectrum_huffman_tree_5() {
  if (spectrum_huffman_tree_5 === undefined) {
    spectrum_huffman_tree_5 = makeHuffmanTree(spectrum_huffman_codebook_5);
  }

  return spectrum_huffman_tree_5;
}


export function get_spectrum_huffman_tree_6() {
  if (spectrum_huffman_tree_6 === undefined) {
    spectrum_huffman_tree_6 = makeHuffmanTree(spectrum_huffman_codebook_6);
  }

  return spectrum_huffman_tree_6;
}


export function get_spectrum_huffman_tree_7() {
  if (spectrum_huffman_tree_7 === undefined) {
    spectrum_huffman_tree_7 = makeHuffmanTree(spectrum_huffman_codebook_7);
  }

  return spectrum_huffman_tree_7;
}


export function get_spectrum_huffman_tree_8() {
  if (spectrum_huffman_tree_8 === undefined) {
    spectrum_huffman_tree_8 = makeHuffmanTree(spectrum_huffman_codebook_8);
  }

  return spectrum_huffman_tree_8;
}


export function get_spectrum_huffman_tree_9() {
  if (spectrum_huffman_tree_9 === undefined) {
    spectrum_huffman_tree_9 = makeHuffmanTree(spectrum_huffman_codebook_9);
  }

  return spectrum_huffman_tree_9;
}


export function get_spectrum_huffman_tree_10() {
  if (spectrum_huffman_tree_10 === undefined) {
    spectrum_huffman_tree_10 = makeHuffmanTree(spectrum_huffman_codebook_10);
  }

  return spectrum_huffman_tree_10;
}


export function get_spectrum_huffman_tree_11() {
  if (spectrum_huffman_tree_11 === undefined) {
    spectrum_huffman_tree_11 = makeHuffmanTree(spectrum_huffman_codebook_11);
  }

  return spectrum_huffman_tree_11;
}


export function makeHuffmanTree(huffmanTable: number[][]): HuffmanTree {
  const root: HuffmanNode = [-1, -1];
  for (let i = 0; i < huffmanTable.length; i++) {
    const nBits = huffmanTable[i][0];
    const value = huffmanTable[i][1];

    encode(root, nBits, value, i);
  }
  return root;
}


function encode(node: HuffmanNode, nBits: number, value: number, leafValue: number) {
  const bitValue = (value >> (nBits - 1)) & 1;
  if (nBits === 1) {
    node[bitValue] = leafValue;
    return;
  }

  if (node[bitValue] === -1) {
    node[bitValue] = [-1, -1];
  }

  const n = node[bitValue];
  invariant(n !== -1 && typeof n !== 'number', 'Invalid node');

  encode(n, nBits - 1, value, leafValue);
}


export function decodeHuffman(bitReader: BitReader, tree: HuffmanTree): number {
  while (typeof tree !== 'number') {
    const bit = bitReader.readBits(1);
    tree = tree[bit];
  }
  return tree;
}
